import sdk2 from '@nicolaudie-group/lscore-sdk2-ts'
import sdk3 from '@nicolaudie-group/lscore-sdk3-ts'

export {
  sdk2 as v2,
  sdk3 as v3,
}

export * as SDKTypes from '@nicolaudie-group/lscore-sdk3-ts'
export * as SDKTypes2 from '@nicolaudie-group/lscore-sdk2-ts'
export * as SDKTypes3 from '@nicolaudie-group/lscore-sdk3-ts'
